var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.472 4.226L4.91 9.787a1.166 1.166 0 000 1.648v0a1.166 1.166 0 001.649 0l5.489-5.489c.91-.91.91-2.386 0-3.297v0a2.331 2.331 0 00-3.297 0L2.975 8.426a3.5 3.5 0 000 4.95v0a3.5 3.5 0 004.95 0l5.848-5.849",
    stroke: "#386EE7",
    strokeWidth: 1.2
  })));
}
export default __webpack_public_path__ + "static/attach-large.e20ec5e0.svg";
export { SvgAttachLarge as ReactComponent };